import * as UI from "@iyk/ui"
import * as React from "react"

import { setThemeTo } from "../../lib/utils/classname.ts"

// #region Banner

export const Banner = React.forwardRef<HTMLDivElement, BannerProps>(
  ({ avatarUrl, bannerUrl }, ref) => {
    return (
      <UI.Stack ref={ref} className="relative h-[170px] md:h-60 flex bg-black">
        {bannerUrl ? (
          <>
            <UI.Layer
              className="bg-cover bg-center"
              style={{ backgroundImage: `url(${bannerUrl})` }}
            />
            <UI.Layer className="bg-black/40 bg-[linear-gradient(0deg,rgba(0,0,0,0)_0%,rgba(0,0,0,0.5)_100%)]" />
          </>
        ) : (
          <UI.Layer className={classNameForLinesShaderContainer()}>
            <UI.LinesShader className="absolute inset-0" showGradient={false} />
          </UI.Layer>
        )}
        <UI.Layer className="max-w-screen-2xl mx-auto px-4 md:px-12 size-full flex flex-col justify-end bg-cover bg-center">
          <UI.Avatar
            variant="square"
            className="size-20 translate-y-10 border-4 border-background rounded"
            src={avatarUrl}
          />
        </UI.Layer>
      </UI.Stack>
    )
  },
)

export type BannerProps = {
  avatarUrl: string
  bannerUrl: string | null
}

const classNameForLinesShaderContainer = UI.cva([setThemeTo("dark"), "relative"])

// #endregion
